import { useState } from 'react'
import { Modal } from './Modal.js'
import { Przycisk } from './Przycisk.js'

/**
 * Modal potwierdzenia zamiast `window.confirm`.
 *
 * Natywne okno przeglądarki wygląda obco, blokuje cały wątek i w aplikacji
 * dodanej do ekranu głównego potrafi wyglądać jak błąd systemu. Ten modal
 * korzysta z tej samej pułapki na fokus i tych samych przejść, co reszta
 * interfejsu.
 */
export function Potwierdzenie({
  tytul,
  tresc,
  etykietaPotwierdz = 'Potwierdź',
  niebezpieczne = false,
  onPotwierdz,
  onAnuluj,
}: {
  tytul: string
  tresc: string
  etykietaPotwierdz?: string
  niebezpieczne?: boolean
  onPotwierdz(): void | Promise<void>
  onAnuluj(): void
}) {
  const [pracuje, ustawPracuje] = useState(false)

  async function potwierdz() {
    if (pracuje) return
    ustawPracuje(true)
    try {
      await onPotwierdz()
    } finally {
      ustawPracuje(false)
    }
  }

  return (
    <Modal
      tytul={tytul}
      onZamknij={onAnuluj}
      stopka={
        <>
          <Przycisk wariant="drugi" onClick={onAnuluj}>
            Anuluj
          </Przycisk>
          <Przycisk
            wariant={niebezpieczne ? 'niebezpieczny' : 'glowny'}
            pracuje={pracuje}
            onClick={() => void potwierdz()}
          >
            {etykietaPotwierdz}
          </Przycisk>
        </>
      }
    >
      <p className="potwierdzenie__tresc">{tresc}</p>
    </Modal>
  )
}
